import * as AgentActions from 'utils/agent-endpoint';
import { SearchStrategy, SearchStrategyProps, SearchResult } from './SearchStrategy';

export class AgentSearchStrategy implements SearchStrategy {
  async search(props: SearchStrategyProps): Promise<SearchResult> {
    try {
      const { queryString, siteLocation } = props;
      const data = await AgentActions.locationSuggestions(queryString, siteLocation);
      const searchAgentPredictions = data.map((label, index) => ({ 
        identifier: index, 
        label, 
        group: 'locations', 
      }));
      
      return {
        searchPredictions: [],
        searchAgentPredictions,
      };
    } catch (err) {
      console.error(err);
      return {
        searchPredictions: [],
        searchAgentPredictions: [],
      };
    }
  }
} 